import type { CtaType } from "@vital/shared";
import { cmsStrings } from "../terminology";

type Props = {
  title: string;
  body: string;
  badge: string;
  ctaLabel: string;
  ctaType: CtaType | null;
  imageUrl?: string | null;
  imageAlt?: string;
};

export function PromotionPreview({
  title,
  body,
  badge,
  ctaLabel,
  ctaType,
  imageUrl,
  imageAlt = "",
}: Props) {
  const hasCta = ctaType !== null && ctaLabel.trim().length > 0;
  const c = cmsStrings.promotionsComposer;

  return (
    <div className="login-preview" aria-label={c.previewAria}>
      <p className="login-preview__viewport">
        <bdi dir="ltr" className="ltr-isolate latin-digits">
          320px
        </bdi>
      </p>
      <div className="login-preview__device">
        <header className="login-preview__brand">
          <p className="login-preview__brand-en ltr-isolate" dir="ltr">
            {cmsStrings.brand.nameEn}
          </p>
          <p className="login-preview__tagline">{c.previewTagline}</p>
        </header>
        <div className="login-preview__card">
          <p className="login-preview__welcome">{c.previewWelcome}</p>
          <article className="login-preview__promotion promotion-preview-card">
            {badge.trim() ? (
              <span className="promotion-preview-card__badge">{badge}</span>
            ) : null}
            {imageUrl ? (
              <img
                className="promotion-preview-card__image"
                src={imageUrl}
                alt={imageAlt || title}
              />
            ) : (
              <div className="promotion-preview-card__icon" aria-hidden="true">
                ★
              </div>
            )}
            <h3 className="promotion-preview-card__title">{title.trim() || c.previewEmptyTitle}</h3>
            <p className="promotion-preview-card__body">{body.trim() || c.previewEmptyBody}</p>
            {hasCta ? (
              <button type="button" className="promotion-preview-card__cta" disabled>
                {ctaLabel}
              </button>
            ) : null}
          </article>
          <div className="login-preview__fields" aria-hidden="true">
            <span className="login-preview__field-label">{c.previewUsername}</span>
            <span className="login-preview__field" />
            <span className="login-preview__field-label">{c.previewPassword}</span>
            <span className="login-preview__field" />
            <span className="login-preview__submit">{c.previewLoginSubmit}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
